module["exports"] = ["#{Address.state} #{creature}"];